<template>
    <div
        :class="[
            'cz2__panel-header',
            'cz3__panel-header--' + align,
        ]"
    >
        <div
            class="cz2__type__small-header"
            v-html="title"
        ></div>
        <div
            v-if="subtitle !== null"
            class="cz2__type__micro cz2__text--center hide--above-sm cz2__panel-header__sub-title"
            v-html="subtitle"
        ></div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__panel-header {
            display: block;
            align-items: flex-start;
            text-align: center;
            min-height: 44px;

            &.cz3__panel-header--left {
                text-align: left;
            }

            @include respond-above(sm) {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                text-align: left;
                margin-bottom: 10px;
            }
        }

        .cz2__panel-header__sub-title {
            margin-top: 5px;
            padding-bottom: 15px;

            font-size: 14px;
        }
    }
</style>

<script>
    export default {
        components: {},
        props: {
            title: String,
            subtitle: {
                type: String,
                default: null,
            },
            align: {
                type: String,
                default: 'center',
            },
        },
        data() {
            return {};
        },
        computed: {},
        methods: {},
    };
</script>
